import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';

export default {
  emits: ['newSubject'],

  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
  },
  data() {
    return ({
      token_exists: false,
      user_details: {
        "user_role": '',
        "user_id": '',
      },
      isSubmitting: false,
      subjects: [],
      created_by_id: this.created_by,
      portals: [],
      isMaster: false,
      categories: [],
      selectedPortalId: null,
      selectedTopicId: null,
      searchQuery: "",
      errors: {
        voice_description: null,
        voice_name: null,
        portal: null,
        subject: null,
        report_description: null
      },
      users: [],
      portal_types: [],
      selectedPortalType: null,
      payload: {},
      reviewers: [],
      event_types: [],
      event_type: '',
      subject_name: '',
    });
  },
  methods: {
    getToken() {
      return get_token();
    },
    validationSubjectForm() {
      this.errors = {};
      let valid = true;

      if (!this.subject_name) {
        this.errors.subject_name = 'Subject name is required';
        valid = false;
      }

      if (!this.selectedPortalId) {
        this.errors.portal = "You must tag a portal.";
      }

      return valid;
    },
    createSubject() {
      if (!this.validationSubjectForm()) {
        return;
      }

      this.isSubmitting = true;

      const requestData = {
        subject_name: this.subject_name,
      };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_subject/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          this.$emit('newSubject', response.subject)


          const status = response.status;
          if (status === "success") {
            Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: response.message,
                      showConfirmButton: false,
                      timer: 2000,
                      position: 'bottom-end',
                      toast: true
            }).then(() => {
            this.subjects.push(response.subject);

            this.subject_name = '';
            this.errors.subject_name = '';
            $('#subject_modal').modal('hide');

          })}
        },
        error: (response) => {
          const response_data = response.responseJSON;

          if (response_data) {
            // If backend returned a general error message
            if (response_data.status === "error") {
              this.errors.subject_name = response_data.message;
            }
          } else {
            // Fallback message
            this.errors.subject_name = "An unexpected error occurred. Please try again.";
          }
        },

        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
  }
}
